/* @flow */
import React from 'react';

import './styles/ReceiptBody.scss';

const ReceiptBody = React.createClass({
  render() {
    return (
      <tbody className="ReceiptBody">
        {this.props.children}
      </tbody>
    );
  },
});

export default ReceiptBody;



// WEBPACK FOOTER //
// ./src/payments/components/ReceiptBody.jsx